import { Component, OnInit } from '@angular/core';
import { ChartDataset, ChartType } from 'chart.js';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TradeModalComponent } from '../../trade-modal/trade-modal.component';
import { MatchBoardState } from '../../../store/state/reducers/matchboard.reducers';
import { Store } from '@ngrx/store';
import {
  getAbosPositions,
  getCurrencyMappingsSelector,
  getSpotPricesSelector
} from '../../../store/state/selectors/matchboard.selectors';
import { CurrencyPosition } from '../../../models/CurrencyPosition';
import { PriceService } from '../../../services/price.service';
// import * as pluginDataLabels from 'chartjs-plugin-datalabels';


@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']

})
export class MyAccountComponent implements OnInit {

  modalRef: BsModalRef;
  positions: Array<CurrencyPosition>;
  spotPrices: any;
  currencyMappings: any;

  // public barChartPlugins = [pluginDataLabels];

  public barChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      enabled: true
    },

    // legend: {
    //   labels: {
    //     fontSize: 0
    //   }
    // },
    // tooltips: {
    //   callbacks: {
    //     label: function(tooltipItem) {
    //       console.log(tooltipItem)
    //       return tooltipItem.yLabel;
    //     }
    //   }
    // },

    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end'
      }
    },


    scales : {
      yAxes: [{
        ticks: {
          // max: 10,
          // min: 0,
          callback: (value) => {

            let suffix = 'M';
            let result = value;
            if (value < 1) {
              suffix = 'K';
              result = Number(value) * 1000;
            }

            return  '$' + result + suffix;
          }
        }
      }]
    }
  };
  // public barChartLabels: Label[] = ['USD', 'BTC', 'JPY', 'ETH'];
  public barChartLabels: any[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = false;
  // public barChartPlugins = [];

  // public barChartData: ChartDataSets[] = [{ data: [0.59, 1.2, 0.13, 0.6] }];
  public barChartData: ChartDataset[] = [{ data: [] }];

  public barChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(94, 54, 143, 0.8)'
    }
  ];

  public chartClicked(event) {

    // const label = event.active[0]._model.label;
    // const sixLetterCode = label === 'BTC' ? 'BTCUSD' : 'BTC' + label;
    // const price: Map<Direction, Array<Price>> = this.stateService.getTopOrdersForCurrencyPair(sixLetterCode);
    //
    // const initialState = {
    //   trade: new Trade(
    //     null,
    //     sixLetterCode,
    //     100,
    //     price && price[Direction.LEND] ? price[Direction.LEND][0].price : 0,
    //     price && price[Direction.BORROW] ? price[Direction.BORROW][0].price : 0,
    //     100,
    //     0,
    //     'myAccount')
    // };
    // this.openTradeModal(initialState);
  }

  constructor(
    private readonly modalService: BsModalService,
    private readonly matchBoardStore: Store<MatchBoardState>,
    private readonly priceService: PriceService
  ) {
  }

  openTradeModal(initialState) {
    this.modalRef = this.modalService.show(TradeModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      class: 'modal-lg modal-trade',
      initialState
    });

    this.modalRef.content.closeBtnName = 'Close';
  }

  ngOnInit() {
    this.matchBoardStore.select(getSpotPricesSelector).subscribe((spotPrices) => {
      this.spotPrices = spotPrices;
    });
    this.matchBoardStore.select(getCurrencyMappingsSelector).subscribe((currencyMappings) => {
      this.currencyMappings = currencyMappings;
    });
    this.matchBoardStore.select(getAbosPositions).subscribe((positions) => {
      this.positions = positions;
      if (positions) {
        const filteredPositions = positions.filter(p => p.tradePosition > 0 && (p.currency === 'USD' || this.crossPosition(p)));
        this.barChartData[0].data = filteredPositions.map(p => p.currency === 'USD' ? p.tradePosition : this.crossPosition(p));
        this.barChartLabels = filteredPositions.map(p => p.currency);
      }
    });
  }

  crossPosition(p: any) {
    const value = p.tradePosition * this.priceService.getSpotPriceForCurrencyPair(this.spotPrices, this.currencyMappings, p.currency + 'USD');
    if (!value) {
      return null;
    }

    return Number(value.toFixed(0));
  }
}

